export default __webpack_public_path__ + "d9824ca8e55ed2b885fa8bdaaf7502a7.svg";